import { useGridMenuItem } from '@mint-lib/ag-grid/react';

import { itemVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type MenuItemBaseProps = {
  name: string;
  startAdornment: React.ReactNode;
  endAdornment?: React.ReactNode;
  className?: string;
  onHover?: () => void;
  disabled?: boolean;
};

const MenuItemBase = ({
  name,
  startAdornment,
  endAdornment = null,
  className,
  onHover,
  disabled,
}: MenuItemBaseProps) => {
  useGridMenuItem({
    configureDefaults: () => true,
  });

  return (
    <button
      type="button"
      onMouseOver={onHover}
      onFocus={onHover}
      disabled={disabled}
      className={cn(
        disabled && 'cursor-not-allowed!',
        itemVariants({ popoverItem: 'default' }),
        'flex! w-70',
        className,
      )}
    >
      {startAdornment}
      <span>{name}</span>
      <div className="ml-auto">{endAdornment}</div>
    </button>
  );
};

export default MenuItemBase;
